import type { UseFormRegister, FieldErrors } from 'react-hook-form';
import type { SubscribeFormValues } from '../SubscribeFormSchema';

interface Props {
  register: UseFormRegister<SubscribeFormValues>;
  errors: FieldErrors<SubscribeFormValues>;
  required?: boolean;
}

export default function PhoneField({ register, errors, required }: Props) {
  return (
    <div className="form-row">
      <label className="form-label">Nr telefonu{required ? '*' : ''}</label>
      <input className="form-input js-phone" maxLength={9} {...register('phone')} />
      {errors.phone && <div className="form-error">{errors.phone.message}</div>}
    </div>
  );
}
